import { IKnmExpertType } from 'APIPackage/CatalogsModule/interfaces/IKnmExpertType';

import { IKnmExpertTypeSelectOption } from '../interfaces/IKnmExpertTypeSelectOption';

export const createKnmExpertTypeSelectOption = (knmExpertType: IKnmExpertType): IKnmExpertTypeSelectOption => ({
  ...knmExpertType,
  label: knmExpertType.name,
  value: knmExpertType.code,
});
